import React, { Component } from "react";
import { Row, Col, Grid } from "react-bootstrap";

import Sidebar from "../../Sidebar/Sidebar";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import ItinerariesContent from "./ItinerariesContent";
import ItinerariesSidebar from "./ItinerariesSidebar";
import BannerRectangleLarge from "../../Banner/BannerRectangleLarge";
import BannerRectangle from "../../Banner/BannerRectangle";

import { translate, getLanguage } from "../../Translation/Translation";
import { FETCH_URL } from "../../../utilities";

import ReactGA from "react-ga";

let WINDOW_WIDTH = 0;
class Itineraries extends Component {
  constructor(props) {
    super(props);
    this.state = {
      itineraries: null,
      shouldDisplayReturn: false
    };
  }

  searchItineraries = nextProps => {
    const width = window.innerWidth;
    let range = 3;
    if (width < 1230) {
      range = 2;
    }
    if (width < 1060) {
      range = 1;
    }
    if (width < 410) {
      range = 0;
    }

    return fetch(`${FETCH_URL}/proxy.php?ws=5a84eaef340463398015c41e8361c199`, {
      method: "POST",
      body: JSON.stringify({
        outgoingLocationCode: `${
          nextProps.match.params.from === "ALL"
            ? ""
            : nextProps.match.params.from
        }`,
        incomingLocationCode: `${
          nextProps.match.params.to === "ALL" ? "" : nextProps.match.params.to
        }`,
        outgoingDate: `${nextProps.match.params.sdate}`,
        incomingDate: `${nextProps.match.params.edate}`,
        languageCode: `${getLanguage()}`,
        includeEvents: true,
        dayRange: range
      })
    })
      .then(response => response.json())
      .then(responseJson => {
        localStorage.setItem("outgoingTrip", null);
        localStorage.setItem("incomingTrip", null);

        this.props.data.setOutgoingTrips(responseJson.outgoingTrips);
        this.props.data.setIncomingTrips(responseJson.incomingTrips);
        this.props.data.setIncomingDestinationTrips(
          responseJson.incomingDestinationTrips
        );
        this.props.data.setOutgoingDestinationTrips(
          responseJson.outgoingDestinationTrips
        );
        this.setState({ shouldDisplayReturn: true });

        localStorage.setItem(
          "currentSearch",
          JSON.stringify({
            outgoingLocationCode: `${nextProps.match.params.from}`,
            incomingLocationCode: `${nextProps.match.params.to}`,
            outgoingDate: `${nextProps.match.params.sdate}`,
            incomingDate: `${nextProps.match.params.edate}`,
            languageCode: `${nextProps.data.translation.language}`,
            includeEvents: true,
            dayRange: range
          })
        );
        this.props.data.setUserSelectedDepartureTrip(false);
        this.props.data.setUserSelectedReturnTrip(false);
        this.props.data.setSelectedOutgoingTrip(null);
        this.props.data.setSelectedIncomingTrip(null);

        return responseJson;
      })
      .catch(error => {
        console.error(error);
      });
  };

  componentDidMount() {
    this.searchItineraries(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.match.params.from !==
        nextProps.data.itineraries.searchDeparturePortCode ||
      nextProps.match.params.to !==
        nextProps.data.itineraries.searchArrivalPortCode ||
      nextProps.match.params.sdate !==
        nextProps.data.itineraries.searchStartDay ||
      nextProps.match.params.edate !== nextProps.data.itineraries.searchEndDay
    ) {
      this.searchItineraries(nextProps);
    }
  }

  render() {
    WINDOW_WIDTH = window.innerWidth;

    window.addEventListener("resize", () => {
      const newWidth = window.innerWidth;
       // console.log("WINDOW", WINDOW_WIDTH);
       // console.log("newWidth", newWidth);

      if (newWidth < 410 && WINDOW_WIDTH >= 410) {
        WINDOW_WIDTH = newWidth;
        this.searchItineraries(this.props);
      }
      if (
        newWidth > 410 &&
        newWidth <= 1060 &&
        (WINDOW_WIDTH <= 410 || WINDOW_WIDTH > 1060)
      ) {
        WINDOW_WIDTH = newWidth;
        this.searchItineraries(this.props);
      }
      if (
        newWidth > 1060 &&
        newWidth <= 1230 &&
        (WINDOW_WIDTH <= 1060 || WINDOW_WIDTH > 1230)
      ) {
        WINDOW_WIDTH = newWidth;
        this.searchItineraries(this.props);
      }
      if (newWidth > 1230 && WINDOW_WIDTH <= 1230) {
        WINDOW_WIDTH = newWidth;
        this.searchItineraries(this.props);
      }
    });

    const { data } = this.props;
    let tripList;
    let arrayToMap;

    if (
      data.settings.departurePortCode === "ALL" ||
      data.settings.arrivalPortCode
    ) {
      arrayToMap = [
        ...data.itineraries.outgoingDestinationTrips,
        ...data.itineraries.incomingDestinationTrips
      ];
    }

    if (
      data.settings.departurePortCode === "ALL" ||
      data.settings.arrivalPortCode === "ALL"
    ) {
      tripList = arrayToMap.map((trip, index) => {
        return (
          <ItinerariesContent
            key={index}
            data={this.props}
            outgoingTripList={trip.trips}
            language={getLanguage()}
          />
        );
      });
    } else {
      tripList = (
        <ItinerariesContent
          data={this.props}
          outgoingTripList={data.itineraries.OutgoingTripList}
          language={getLanguage()}
        />
      );
    }

    return (
      <div>
        <Grid fluid className="no-padding">
          <Row style={{ margin: "0px" }}>
            <Col style={{ margin: "0px" }}>
              <Header data={this.props} />
            </Col>
          </Row>
          <Row style={{ margin: "0px" }}>
            <div className="OSPageContainer">
              <div className="OSPageContent contentOnMDandBelow">
                <Row style={{ margin: "0px", marginTop: "20px" }}>
                  <div className="stepCounter">1</div>
                  <div className="stepLabel">
                    {translate(getLanguage(), "Select Travel Dates")}
                  </div>
                </Row>
                {tripList}
              </div>
              <div className="OSPageSidebar showOnMDandBelow">
                <ItinerariesSidebar
                  incomingTrip={
                    this.props.data &&
                    this.props.data.itineraries.selectedIncomingTrip
                  }
                  outgoingTrip={
                    this.props.data &&
                    this.props.data.itineraries.selectedOutgoingTrip
                  }
                  shouldDisplayReturn={this.state.shouldDisplayReturn}
                  language={getLanguage()}
                />
              </div>
              <div className="OSPageSidebar">
                <ItinerariesSidebar
                  incomingTrip={
                    this.props.data &&
                    this.props.data.itineraries.selectedIncomingTrip
                  }
                  outgoingTrip={
                    this.props.data &&
                    this.props.data.itineraries.selectedOutgoingTrip
                  }
                  shouldDisplayReturn={this.state.shouldDisplayReturn}
                  language={getLanguage()}
                />
                <Sidebar />
              </div>
            </div>
          </Row>
          <Row style={{ margin: "24px 0px 24px 0" }}>
            <div className="displayBannerLarge">
              <BannerRectangleLarge />
            </div>
          </Row>
          <Row>
            <Col xs={12} sm={6} mdHidden lgHidden>
              <BannerRectangle />
            </Col>
            <Col xsHidden sm={6} mdHidden lgHidden>
              <BannerRectangle />
            </Col>
          </Row>
          <Row style={{ margin: "0px" }}>
            <Footer />
          </Row>
        </Grid>
      </div>
    );
  }
}

export default Itineraries;



// WEBPACK FOOTER //
// ./src/components/Pages/Itineraries/Itineraries.js